import { cn } from '@/lib/utils'

interface TypingIndicatorProps {
  variant?: 'dots' | 'pulse' | 'wave'
  text?: string
  className?: string
}

export function TypingIndicator({
  variant = 'dots',
  text = 'Thinking',
  className,
}: TypingIndicatorProps) {
  if (variant === 'pulse') {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <span className="text-sm text-muted-foreground">{text}</span>
        <div className="flex gap-1">
          <div className="h-2 w-2 rounded-full bg-primary/60 animate-pulse" />
          <div className="h-2 w-2 rounded-full bg-primary/60 animate-pulse [animation-delay:150ms]" />
          <div className="h-2 w-2 rounded-full bg-primary/60 animate-pulse [animation-delay:300ms]" />
        </div>
      </div>
    )
  }

  if (variant === 'wave') {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <span className="text-sm text-muted-foreground">{text}</span>
        <div className="flex gap-0.5 items-end h-4">
          {[0, 1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="w-1 bg-primary/60 rounded-full animate-wave"
              style={{
                animationDelay: `${i * 100}ms`,
                height: '100%',
              }}
            />
          ))}
        </div>
      </div>
    )
  }

  // Default: dots variant
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="text-sm text-muted-foreground">{text}</span>
      <div className="flex gap-1">
        <div className="h-1.5 w-1.5 rounded-full bg-foreground/40 animate-bounce [animation-delay:0ms]" />
        <div className="h-1.5 w-1.5 rounded-full bg-foreground/40 animate-bounce [animation-delay:150ms]" />
        <div className="h-1.5 w-1.5 rounded-full bg-foreground/40 animate-bounce [animation-delay:300ms]" />
      </div>
    </div>
  )
}
